import { ITextFieldMask } from '../types';

export const getMaskedCursorPosition = (
  mask: ITextFieldMask,
  displayValue: string,
  rawCharactersBeforeCursor: number
) => {
  if (rawCharactersBeforeCursor === 0) {
    return 0;
  }

  for (let index = 1; index <= displayValue.length; index += 1) {
    if (mask.parse(displayValue.slice(0, index)).length >= rawCharactersBeforeCursor) {
      return index;
    }
  }

  return displayValue.length;
};
